import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_SCREEN_TIME_DATA = `${API_URL}/api/v1/parent/screen-time-graph`;

export function getScreenTimeData(payload) {
  return axiosInstance({
    url: GET_SCREEN_TIME_DATA,
    method: "GET",
    params: payload,
  });
}
